<template>
  <app-autocomplete
    filter
    :items="options"
    :label="$t('debtor')"
    label-icon="icon-clients"
    hide-details
    multiple
    dense
    solo
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { mapState } from 'vuex';
import { NAMESPACE } from '@/modules/Debtors/store';

export default {
  name: 'DebtorSelect',

  computed: {
    ...mapState(NAMESPACE, { items: 'debtorNames' }),
    options() {
      return [...new Set(this.items.map(({ name }) => name))].sort((a, b) => a.localeCompare(b));
    }
  }
};
</script>
